import { render, staticRenderFns } from "./listcert.vue?vue&type=template&id=5ae10b8d&scoped=true&"
import script from "./listcert.vue?vue&type=script&lang=js&"
export * from "./listcert.vue?vue&type=script&lang=js&"
import style0 from "./listcert.vue?vue&type=style&index=0&id=5ae10b8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae10b8d",
  null
  
)

export default component.exports